import React from 'react';

export function makeBootstrapRows(items, itemsPerRowCount) {
  let groupedItems = items
    .map((x, i) => {
      return i % itemsPerRowCount === 0 ? items.slice(i, i + itemsPerRowCount) : null;
    })
    .filter(x => x != null);
  return (
    <div>
      {groupedItems.map((item, index) => {
        return (
          <div key={index} className="row">
            {item}
          </div>
        );
      })}
    </div>
  );
}
